// Landing/SocialButtons.tsx

import React from 'react';
import {FRCC} from "WideLayout/Layouts"; // Убедитесь, что путь правильный
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faOdnoklassniki, faVk} from '@fortawesome/free-brands-svg-icons';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {useTheme} from "Theme/ThemeContext";
import yaZen from '../Static/img/icon/social/yandex-zen.svg';
import {ContainerProps} from "WideLayout/Container";
import {companyLinks} from "Company/companyLinks";

interface SocialLink {
    name: string;
    icon: JSX.Element;
    link: string;
    color: string;
}

interface SocialButtonsProps extends Partial<ContainerProps> {
    exclude?: string[];
    iconStyle?: React.CSSProperties;
    containerProps?: ContainerProps;
}

const SocialButtons: React.FC<SocialButtonsProps> = ({
                                                         exclude = [],
                                                         iconStyle,
                                                         containerProps = {},
                                                         ...restContainerProps
                                                     }) => {
    const {plt} = useTheme();

    const socialLinks: SocialLink[] = [
        {
            name: "Vk",
            icon: <FontAwesomeIcon icon={faVk} size="2x" style={{cursor: 'pointer'}}/>,
            link: companyLinks.vk,
            color: "#5490ff"
        },
        {
            name: "TelegramSocial",
            icon: <TelegramIcon style={{width: '40px', height: '40px', cursor: 'pointer', color: '#48b9ff'}}/>,
            link: companyLinks.telegramSocial,
            color: "#48b9ff"
        },
        {
            name: "Odnoklassniki",
            icon: <FontAwesomeIcon icon={faOdnoklassniki} size="2x" style={{cursor: 'pointer'}}/>,
            link: companyLinks.odnoklassniki,
            color: "#F7931E"
        },
        {
            name: "YandexZen",
            icon: <img src={yaZen} alt="Яндекс.Дзен" style={{width: '32px', height: '32px', cursor: 'pointer'}}/>,
            link: companyLinks.yandexZen,
            color: "#FE6B58"
        },
        {
            name: "WhatsApp",
            icon: <WhatsAppIcon style={{width: '40px', height: '40px', cursor: 'pointer', color: '#25D366'}}/>,
            link: companyLinks.whatsapp,
            color: "#25D366"
        },
        {
            name: "TelegramContact",
            icon: <TelegramIcon style={{width: '43px', height: '43px', cursor: 'pointer', color: '#48b9ff'}}/>,
            link: companyLinks.telegramContact,
            color: "#48b9ff"
        },
    ];

    const filteredSocialLinks = socialLinks.filter(link => !exclude.includes(link.name));

    // Объединяем containerProps и оставшиеся свойства (например, px, py, rounded и т.д.)
    const combinedContainerProps: ContainerProps = {
        ...containerProps,
        ...restContainerProps
    };

    // Если вдруг в комбинированных пропсах есть ref, удалим его, чтобы избежать ошибок
    const {ref: _ref, ...safeContainerProps} = combinedContainerProps as ContainerProps;

    return (
        <FRCC {...safeContainerProps}>
            {filteredSocialLinks.map((social, index) => (
                <a
                    key={index}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{color: social.color}}
                    aria-label={social.name}
                >
                    {React.isValidElement(social.icon)
                        ? React.cloneElement(social.icon as React.ReactElement, {
                            style: {
                                ...((social.icon as React.ReactElement).props.style || {}),
                                ...iconStyle
                            }
                        })
                        : social.icon}
                </a>
            ))}
        </FRCC>
    );
};

export default SocialButtons;
